









import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { toStyleVal, isNumeric } from '@/utils';

@Component
export default class AxTextBox extends Vue {
  form = {
    value: ''
  };

  textBox = '';
  value!: string;

  @Prop({ type: String, default: null })
  width!: string;

  @Prop({ type: String, default: null })
  height!: string;

  @Prop({ type: String })
  appendIcon!: string;

  @Prop({ type: String, default: 'white' })
  color!: string;

  @Prop({ type: Boolean, default: false })
  lighten!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  outlined!: boolean;

  @Prop({ type: String, default: '' })
  placeholder!: string;

  @Emit()
  input(value: string) {
    // this.value = this.textBox;
    this.form.value = value;
    console.log(value);
    return value;
  }

  get styleVal() {
    const width = isNumeric(this.width) ? this.width + 'px' : this.width;
    const height = isNumeric(this.height) ? this.height + 'px' : this.height;

    return toStyleVal([
      ['width', width],
      ['height', height]
    ]);
  }

  get attrVal() {
    return {
      singleLine: true,
      color: this.color,
      disabled: this.disabled,
      dark: !this.lighten,
      outlined: this.outlined,
      placeholder: this.placeholder,
      appendIcon: this.appendIcon,
      spellcheck: 'false'
    };
  }
}
